// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ClampedTextBox{word-wrap:break-word;height:100%;width:100%;word-break:normal}.ClampedTextBox .more-text{bottom:0;opacity:.45;padding-left:4px;position:absolute;right:0;z-index:3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
